module.exports = __webpack_public_path__ + "img/ai_text_longer.376ab03b.svg";